import React from 'react';
import '../../css/inicio.css';
//imagenes
import Logo from '../../img/logo1.png';
import Demo from '../../img/DemoLogo.png';

export default function Footer() {
    return (
        <footer className="container py-5">
        <div className="row">
        <div className="col-12 col-md">
        <img src={Demo} width="100" height="50"/>
        <small className="d-block mb-3 text-muted">&copy; 2020</small>
        </div>
        <div className="col-6 col-md">
        <h5>Terminos legales</h5>
        <ul className="list-unstyled text-small">
            <li><a className="text-muted" href="/terminosycondiciones"></a></li>
            <li><a className="text-muted" href="/politicaprivacidad">Política de Privacidad</a></li>
            <li><a className="text-muted" href="#"></a></li>
            <li><a className="text-muted" href="#"></a></li>
        </ul>
        </div>
        <div className="col-6 col-md">
        {/*
        <h5>Resources</h5>
        <ul className="list-unstyled text-small">
            <li><a className="text-muted" href="#">Resource</a></li>
            <li><a className="text-muted" href="#">Resource name</a></li>
            <li><a className="text-muted" href="#">Another resource</a></li>
            <li><a className="text-muted" href="#">Final resource</a></li>
        </ul>
        */}
        </div>
        <div className="col-6 col-md">
        {/*
            
        <h5>Resources</h5>
        <ul className="list-unstyled text-small">
            <li><a className="text-muted" href="#">Business</a></li>
            <li><a className="text-muted" href="#">Education</a></li>
            <li><a className="text-muted" href="#">Government</a></li>
            <li><a className="text-muted" href="#">Gaming</a></li>
        </ul>
        */}
        </div>
        <div className="col-6 col-md">
        {/*
        <h5>TERMINOS LEGALES</h5>
        <ul className="list-unstyled text-small">
            <li><a className="text-muted" href="#">Terminos y Condiciones</a></li>
            <li><a className="text-muted" href="#">Política de Privacidad</a></li>
            <li><a className="text-muted" href="#"></a></li>
            <li><a className="text-muted" href="#"></a></li>
        </ul>
        */}
        </div>
    </div>
    </footer>

    )
}
